<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="gotToManageTemplate()"
                  particleAnalytics
                  analyticsCategory="file-manager-content"
                  analyticsAction="Add-Folder">Templates
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          &lt;!&ndash;          [disabled]="!survey.canStartNewExecution" (click)="startSurvey()"&ndash;&gt;-->
        <!--          <button mat-button class="orbitax-flat-button"-->
        <!--                  particleAnalytics-->
        <!--                  analyticsCategory= "file-manager-content"-->
        <!--                  analyticsAction= "Add-Folder">Start Data Survey</button>-->
        <!--          <div class="toolbar-separator"></div>-->
        <!--        </div>-->
      </div>
    </div>

  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="data-survey-single-overview" class="content-card mat-white-bg">

        <div class="content pos-relative m-30 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   sortFieldKey="ModifiedDate"
                                   sortDirection="desc"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   [invalidateSubject]="invalidateSubject"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

